__turbopack_context__.v({
  "brandBackgroundGradient": "BrandCardGrid-module__BNODpq__brandBackgroundGradient",
  "brandCard": "BrandCardGrid-module__BNODpq__brandCard",
  "brandGrid": "BrandCardGrid-module__BNODpq__brandGrid",
  "brandInfo": "BrandCardGrid-module__BNODpq__brandInfo",
  "brandName": "BrandCardGrid-module__BNODpq__brandName",
  "cardImage": "BrandCardGrid-module__BNODpq__cardImage",
  "fadeIn": "BrandCardGrid-module__BNODpq__fadeIn",
  "logoFloat": "BrandCardGrid-module__BNODpq__logoFloat",
  "noResults": "BrandCardGrid-module__BNODpq__noResults",
  "noResultsDesc": "BrandCardGrid-module__BNODpq__noResultsDesc",
  "noResultsTitle": "BrandCardGrid-module__BNODpq__noResultsTitle",
});
